class HydrantQuantity extends HTMLElement {
	constructor() {
		super()
		this.addMore = this.querySelector(".add-more")
		this.addLess = this.querySelector(".add-less")
		this.quantity = this.querySelector(".qty-input")

		this.MAX_VALUE = 99
		this.MIN_VALUE = 0
	}

	//Check each item width. and based on the item width we gonna offset the parent by that.
	//Make sure to store

	connectedCallback() {
		this.addMore.addEventListener("click", $event => {
			$event.preventDefault()
			if (this.quantity.disabled) return
			this.quantity.value = Math.min(this.MAX_VALUE, parseInt(this.quantity.value) + 1)
			this.quantity.dispatchEvent(new Event("input"))
			this.quantity.dispatchEvent(new Event("change"))
		})
		this.addLess.addEventListener("click", $event => {
			$event.preventDefault()
			if (this.quantity.disabled) return
			this.quantity.value = Math.max(this.MIN_VALUE, parseInt(this.quantity.value) - 1)
			this.quantity.dispatchEvent(new Event("input"))
			this.quantity.dispatchEvent(new Event("change"))
		})
		this.quantity.addEventListener("input", $event => {
			if ($event.target.value > this.MAX_VALUE) return ($event.target.value = this.MAX_VALUE)
		})
	}
}

customElements.define("hydrant-quantity", HydrantQuantity)
